import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,{staticClass:"d-flex align-center",attrs:{"outlined":""}},[_c('div',[_c(VCardText,{staticClass:"body-2"},[_c('p',{staticClass:"mb-0"},[_c(VIcon,{staticClass:"mt-n1",attrs:{"small":"","color":"green"}},[_vm._v("mdi-check-circle")]),_vm._v(" Vous n'avez pas d'actions en attente pour vos établissements ")],1)])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }